export default __webpack_public_path__ + "static/media/co2.ae1e3f75.svg";